import React, { useState, useEffect } from "react";
import axios from 'axios';
import './../styles/ecom.css';
import './../styles/ecom/home.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './ecom/Navbartop';
import Footer from './ecom/Footer';

import banner1 from './../components/banner1.jpg';
import { Link } from 'react-router-dom';

const Home = () => {
    let path_api = localStorage.getItem('path_api');
    const [productos, setProductos] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const images = [
        "https://ecommerce.zadrigman.com/backend/images/galeria/img_67585471966ee5.29878734.webp",
        "https://ecommerce.zadrigman.com/backend/images/galeria/img_6758547197cab7.20549931.webp",
        "https://ecommerce.zadrigman.com/backend/images/galeria/img_67585471981e92.16757074.webp",
        "https://ecommerce.zadrigman.com/backend/images/galeria/img_6758547198d996.07655080.webp"
    ];

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, []);

    useEffect(() => {
        setProductos([]);
        get_productos();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 6000);

        return () => clearInterval(interval);
    }, [images.length]);

    const get_productos = async () => {
        await axios.post(`${path_api}/ecom/productos.php`, {
            rute: globals.getRuteBackend(),
            limit: 10
        }).then(response => {
            if (response.data.mensaje === "success") {
                const productosObtenidos = response.data.productos.map(producto => ({
                    id: producto.id,
                    nombre: producto.nombre,
                    precio: producto.data ? JSON.parse(producto.data).variaciones[0].precio : null,
                    imagen: producto.data ? JSON.parse(producto.data).imagenes[0].url : null,
                }));

                const shuffleArray = (array) => {
                    for (let i = array.length - 1; i > 0; i--) {
                        const j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]];
                    }
                    return array;
                };

                const productosRandom = shuffleArray(productosObtenidos);

                setProductos(productosRandom);
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "No se obtuvieron los productos", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error 'log-productos-1'", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-home">
                <div className="slider">
                    <div className="slide" style={{ backgroundImage: `url(${banner1})` }}>
                        <div className='overlay-slider'></div>
                        <div className="content">
                            <h1>Tu compra, su futuro brillante</h1>
                            <p>Gracias a tu apoyo, seguimos transformando vidas y construyendo un mundo mejor para ellos. Juntos, marcamos la diferencia.</p>
                            <Link to="/categorias/zadrigman" className="button-primary green">Explorar</Link>
                        </div>
                    </div>
                </div>
                <div className="page-container">
                    <div className='container-section flex-column gap-20'>
                        <h1 className="no-margin">Productos destacados</h1>

                        <div className="productos-row">
                            {productos.map(producto => (
                                <Link to={`/productos/${producto.id}`} className="producto-card" key={producto.id}>
                                    <img src={producto.imagen} alt={producto.nombre} className="producto-imagen" loading="lazy" />
                                    <div className="content">
                                        <h5>{producto.nombre}</h5>
                                        <p>${producto.precio} MXN</p>
                                    </div>
                                </Link>
                            ))}
                            <div className="flex-column center2">
                                <Link to="/colecciones/destacados" className="button-primary">Ver más</Link>
                            </div>
                        </div>
                    </div>

                    <div className='container-section flex-column center gap-20 black banner'>
                        <h1 className="center no-margin">¡La mejor elección para ti!</h1>
                        <p className="center no-margin">
                            Descubre la comodidad y el estilo único de nuestras <b style={{ color: 'var(--color-green)' }}>sudaderas</b>. Diseñadas para acompañarte en cualquier momento, son la combinación perfecta de calidad y tendencia.
                        </p>

                        <div className="gallery">
                            {images.map((src, index) => (
                                <div
                                    key={index}
                                    className={`image ${index === activeIndex ? 'rotate' : ''}`}
                                >
                                    <img src={src} alt={`Image ${index + 1}`} loading="lazy" />
                                </div>
                            ))}
                        </div>

                        <Link to="/productos/11" className="button-primary green">¡Quiero la mía ahora!</Link>

                        <p className="center no-margin">
                            ¿Todavía tienes dudas? Estamos seguros de que te encantarán desde el primer uso.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;
